<template>
  <div class="histogram-container">
    <div class="histogram-container-header">
      <div class="title">{{ title }}</div>
      <div class="mode-slider">
        <div
          @click="mode = 'hours'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'hours' }"
        >
          {{ $t('stats_histogram.hour')}}
        </div>
        <div
          @click="mode = 'days'"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'days' }"
        >
          {{ $t('stats_histogram.day')}}
        </div>
      </div>
    </div>
    <div class="histogram">
      <div class="histogram-bg">
        <div class="histogram-line" v-for="milestone in milestones" :key="milestone">
          {{ milestone}}
          <div></div>
        </div>
      </div>
      <div
        :class="{
          'histogram-data-container': true,
          'day-mode': mode == 'days',
        }"
      >
        <div
          v-for="label in labels"
          :key="label.raw"
          class="histogram-data-column"
        >
          {{ label.text }}
          <div class="bottom-part">
            <div class="data-col" :style="`height:${(targetHistogram[label.raw] || 0) * columnSize}vh`"></div>
            <div>{{ targetHistogram[label.raw] || 0 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      mode: "hours",
    };
  },
  props: {
    hourlyHistogram: Object,
    dailyHistogram: Object,
    title: String
  },
  methods: {},
  computed: {
    dayNames() {
      const names = [];
      for (let i = 1; i < 8; i++) {
        names.push(
          {
            text: moment().day(i).format('dd'),
            raw: i
          }
        );
      }
      return names; 
    },
    hoursNames() {
      const names = [];
      for (let i = 0; i < 24; i++) {
        names.push(
          {
            raw: i,
            text: i
          }
        );
      }
      return names; 
    },
    labels() {
      return this.mode == 'hours' ? this.hoursNames : this.dayNames;
    },
    targetHistogram() {
      return this.mode == 'hours' ? this.hourlyHistogram : this.dailyHistogram;
    },
    totalCount() {
      return Object.values(this.targetHistogram).reduce((acc,it) => acc + it, 0);
    },
    maxCount() {
      return Object.values(this.targetHistogram).reduce((acc,it) => acc < it ? it : acc);
    },
    milestones() {
      const chunk_size = Math.round(
        this.maxCount / 3
      );

      return [
        this.maxCount,
        chunk_size * 1,
        chunk_size * 0 
      ]
    },
    columnSize() {
      //MAX_HEIGHT - max_count
      //x - 1
      const CSS_MAX_HEIGHT = 10.888; //vh
      return CSS_MAX_HEIGHT / this.maxCount;
    }
  }
};
</script>
<style scoped>
.histogram-container {
  width: 100%;
  padding: 2.222vh;
  background: #e5e5e5;
  border-radius: 1.333vh;
  margin-top: 3.333vh;
  box-sizing: border-box;
}
.histogram-container-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.222vh;
}
.title {
  font-size: 2.777vh;
  line-height: 3.222vh;
  display: flex;
  align-items: center;
  color: #908f8d;
}
.mode-slider {
  height: 3.666h;
  background: #ededed;
  border-radius: 0.444vh;
  display: flex;
}
.mode-slide-btn {
  width: 26.22222222222222vh;
  height: 3.666vh;
  border-radius: 0.444vh;
  font-size: 2vh;
  line-height: 2.3333333333333335vh;
  color: #908f8d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.active-mode {
  background: #1d1d1b;
  color: #ededed;
}
.histogram {
  width: 100%;
  position: relative;
  padding: 2.111111111111111vh 0;
  box-sizing: border-box;
}
.histogram-bg {
  width: 100%;
  box-sizing: border-box;
}
.histogram-line {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 1.666vh;
  line-height: 1.888vh;
  color: #908f8d;
  margin-bottom: 3.555vh;
}

.histogram-line:last-child {
  margin-bottom: 0;
}
.histogram-line div {
  width: calc(100% - 4.444vh);
  background-image: linear-gradient(
    to right,
    #c4c4c4 30%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 1.444vh 0.1111vh;
  background-repeat: repeat-x;
  height: 0.1111vh;
  margin-left: 1.1111111111111112vh;
}
.histogram-data-container {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
  padding-left: 5.555555555555555vh;
  padding-right: 1.1111111111111112vh;
  top: 0;
  box-sizing: border-box;
}
.day-mode {
  padding: 0 4.444444444444445vh 0 10vh;
}
.histogram-data-column {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 2.87%;
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #129b81;
}
.histogram-data-column div {
  width: 100%;
}
.data-col {
  min-height: 0.1111vh;
  background: #129b81;
  border-radius: 0.3333333333333333vh;
  margin-bottom: 1.1111vh;
  width: 100% !important;
  max-height: 10.888vh;
}
.bottom-part {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.bottom-part div {
  width: 98%;

  color: #908f8d;
}
</style>
